/* global G */
import seqReset from '@gaia/sequence/model/api/reset'

const descriptor = Symbol('hook::model::attribute::reset').toString()

/**
 * Model Attribute Reset Hook
 *
 * Works like {@link reset}, but for `attribute` sub model
 *
 * @param  {string} attribute the attribute to reset
 * @returns {function(...[*]): *[]}
 */
const modelReset = attribute => obj => (...args) => {
  const model = obj[G.MODEL][G.CHILDREN][attribute]
  try {
    seqReset(model)
  } catch (e) {
    throw Error(`${obj._name} ${descriptor} - ${e.message}`)
  }
  return args
}

export default modelReset
